/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import PageContainer from 'components/PageContainer';

import { Box, Container } from '@material-ui/core';
import { Trans } from 'hooks/useTranslate';
import { useMarkdownTranslate } from 'hooks/useTranslate/useTranslate';
import styles from './styles';
import CancelButton from 'features/CancelButton';
import ActionButtonContainer from 'components/ActionButtonsContainer';

interface PropTypes {
  restartPath: string;
}
const AppExpiredView: React.FC<PropTypes> = ({ restartPath }) => {
  const tMd = useMarkdownTranslate();
  return (
    <Box mt={8}>
      <PageContainer>
        <h1 css={styles.headerTitle}>{tMd('appExpired.title')}</h1>

        <Container maxWidth="sm">
          <p css={styles.body}>{tMd('appExpired.expirationMessage')}</p>

          <p css={styles.body}>
            <Trans
              i18nKey="appExpired.restartMessage"
              components={[
                <span />,
                // Not applicable here because the anchor tag is passed into Trans component.
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  css={styles.startOver}
                  href={restartPath}
                  aria-label="Go to the beginning of the application"
                />,
              ]}
            />
          </p>
        </Container>

        <ActionButtonContainer>
          <CancelButton />
        </ActionButtonContainer>
      </PageContainer>
    </Box>
  );
};

export default AppExpiredView;
